import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';

export const slide = () => {
  return (
    <Slide
      notes="Overview of the three main workshop components: ChatGPT basics, CV matcher usage, and troubleshooting"
      transition="fade"
      networkBackground="full"
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <WebContent
          animation={{
            type: 'fade',
            delay: 0,
            duration: 800,
          }}
        >
          <h2 className="text-4xl font-light mb-8">Wat gaan we vandaag doen?</h2>
        </WebContent>

        <div className="space-y-4">
          <WebContent
            animation={{
              type: 'fade',
              delay: 1000,
              duration: 800,
            }}
          >
            <p className="text-2xl font-light">• Basis ChatGPT vaardigheden ontwikkelen</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <p className="text-2xl font-light">• Werken met de Custom GPT CV matcher</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 3000,
              duration: 800,
            }}
          >
            <p className="text-2xl font-light">• Tips & troubleshooting in de praktijk</p>
          </WebContent>
        </div>
      </div>
    </Slide>
  );
};
